export const normalizeUSPhone = (value) => {
  if (!value) return value;
  const currentValue = value.replace("+1", "");

  return `${currentValue.slice(0, 3)}-${currentValue.slice(
    3,
    6
  )}-${currentValue.slice(6, 10)}`;
};
